'use client';

import { Info } from 'lucide-react';

export function TournamentPausedAlert() {
  return (
    <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start gap-3">
        <Info size={20} className="mt-0.5 flex-shrink-0 text-amber-600" />
        <div>
          <h3 className="mb-2 font-semibold text-amber-900">
            Torneo en Estado de Pausa
          </h3>
          <p className="text-sm leading-relaxed text-amber-800">
            Este torneo se encuentra <strong>pausado</strong>. Para habilitarlo
            nuevamente, es necesario{' '}
            <strong>reconectar la cuenta con MercadoPago</strong>. Una vez
            restablecida la conexión, el torneo podrá volver a estar activo y
            disponible para los participantes.
          </p>
        </div>
      </div>
    </div>
  );
}
